module.exports = __webpack_public_path__ + "img/yue.201a9bfa.png";